import { render, staticRenderFns } from "./KioskWrestlerSearch.vue?vue&type=template&id=4a86c9f9&"
import script from "./KioskWrestlerSearch.vue?vue&type=script&lang=js&"
export * from "./KioskWrestlerSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports